"use client";

import { useId } from "react";
import { quarterlyOffers } from "@/lib/plans";

export function QuarterlyOptions({ lbs, onChange, dark = false, disabled = false }: {
  lbs: number; onChange: (lbs: number) => void; dark?: boolean; disabled?: boolean;
}) {
  const name = useId();
  return (
    <fieldset disabled={disabled} className="mt-7 min-w-0">
      <legend className="sr-only">Quarterly size</legend>
      <div className={`grid grid-cols-2 gap-1 rounded-xl p-1 ${dark ? "bg-black/20" : "bg-[#EAF0F8]"}`}>
        {quarterlyOffers().map(option => (
          <label key={option.id} className={`group relative min-w-0 ${disabled ? "cursor-wait opacity-60" : "cursor-pointer"}`}>
            <input type="radio" name={name} value={option.lbs} checked={lbs === option.lbs} onChange={() => onChange(option.lbs)} className="peer absolute inset-0 z-10 h-full w-full cursor-pointer opacity-0 disabled:cursor-wait" />
            {option.id === "big-boy" && <span className="pointer-events-none absolute -top-2.5 left-1/2 z-20 -translate-x-1/2 whitespace-nowrap rounded px-2 py-0.5 text-[10px] font-bold tracking-wide bg-[#F2B705] text-[#2E2404]">2× laundry</span>}
            <span className={`flex min-h-[72px] flex-col items-center justify-center gap-1.5 rounded-lg px-2 py-3 text-center transition-colors duration-150 motion-reduce:transition-none peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-[#F2B705] ${option.id === "big-boy"
              ? lbs === option.lbs
                ? "bg-[#F2B705] text-[#2E2404] ring-1 ring-inset ring-[#F2B705]"
                : dark ? "bg-[#F2B705]/10 text-[#F9D775] ring-1 ring-inset ring-[#F2B705]/70 group-hover:bg-[#F2B705]/20" : "bg-[#FFF7DF] text-[#745200] ring-1 ring-inset ring-[#C18A00] group-hover:bg-[#FFF0C2]"
              : lbs === option.lbs ? "bg-white text-[#243A6B] shadow-sm"
              : dark ? "text-white/80 group-hover:bg-white/10" : "text-[#5E6A80] group-hover:bg-white/50"}`}>
              <span className={`whitespace-nowrap text-sm ${option.id === "big-boy" ? "font-bold" : "font-semibold"}`}>{option.id === "big-boy" ? option.name : "Regular"}</span>
              <span className="flex items-center gap-1.5 text-xs tabular-nums"><span aria-hidden="true" className={`size-2.5 rounded-full border border-current ${lbs === option.lbs ? "bg-current" : ""}`} />{option.lbs} lb</span>
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
